import { render } from "./UnitDetails.vue?vue&type=template&id=861b514e&scoped=true"
import script from "./UnitDetails.vue?vue&type=script&lang=js"
export * from "./UnitDetails.vue?vue&type=script&lang=js"

import "./UnitDetails.vue?vue&type=style&index=0&id=861b514e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861b514e"]])

export default __exports__